// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Suggestions_Wrapper__1PQ9o","Contact":"Suggestions_Contact__Ik30U","NoMatch":"Suggestions_NoMatch__2l4gh"};